import { render, staticRenderFns } from "./ProductOverview.vue?vue&type=template&id=f048b062&scoped=true&"
import script from "./ProductOverview.vue?vue&type=script&lang=js&"
export * from "./ProductOverview.vue?vue&type=script&lang=js&"
import style0 from "./ProductOverview.vue?vue&type=style&index=0&id=f048b062&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f048b062",
  null
  
)

export default component.exports